<template>
    <card-list-item @click="$emit('click')" :class="{'active': active}">
        <template v-slot:icon><i class="fa-fw fa-presentation" :class="{'fas': active, 'far': !active}"></i></template>
        <template v-slot:content>
            <div class="trip-title">{{ conf.name }}</div>
            <div v-if="summary">
                <div class="meta">{{ confDates }}, {{ conf.location }}</div>
<!--                <div class="meta" v-if="conf.revenue || conf.pendingRevenue"><strong>{{ conf.revenue | currency }}</strong> <span v-if="conf.pendingRevenue">({{conf.pendingRevenue | currency}} pending)</span></div>-->
            </div>
        </template>
        <template v-slot:status>
            <div class="stats">
<!--                <span class="stat"><i class="far fa-users"></i>{{ conf.registrations.length }}</span>-->
                <span class="stat" v-if="conf.pending"><i class="far fa-exclamation-triangle"></i>{{ conf.pending }}</span>
            </div>
        </template>
        <template v-slot:details>
            <div class="tile-details">
                <h6 class="mt-1"><b-tag type="is-primary"><i class="far fa-tag ml-1 mr-1"></i> {{conf.code}}&nbsp;</b-tag></h6>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import Toolbar from "@/TIER/components/Toolbar";
    import DataRow from "@/TIER/components/DataRow";
    import CardListItem from "@/TIER/components/CardListItem";
    import moment from "moment";

    export default {
        name: 'ConferenceTileLegacy',
        components: {CardListItem, DataRow, Toolbar},
        props: {
            card: {
                required: true
            },
            conf: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            },
            summary: {
                type: Boolean,
                default: true
            }
        },
        data: function() {
            return {};
        },
        computed: {
            confDates: function() {
                let s = moment(this.conf.startdate);
                let e = moment(this.conf.enddate);
                if (s.isSame(e, 'day')) {
                    return s.format('MMMM D, YYYY');
                } else if (s.isSame(e, 'month')) {
                    return s.format('MMMM D - ') + e.format('D, YYYY');
                } else if (s.isSame(e, 'year')) {
                    return s.format('MMM D - ') + e.format('MMM D, YYYY');
                } else {
                    return s.format('MMM D, YYYY - ') + e.format('MMM D, YYYY');
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import '../../assets/variables';

    li {
        color: darken($t-primary, 18);
        padding: 0.5rem 0;

        .trip-title {
            font-size: .9rem;
            font-weight: 700;
        }

        .tile-details {
            margin-top: 0.5rem;
        }

        .fa-exclamation-triangle {
            color: orangered;
        }
    }
</style>
